<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card class="pb-12">
          <probation-container-view />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    components: {
      ProbationContainerView: () => import('@/components/hris/probation/ContainerView'),
    },
    metaInfo () {
      return {
        title: 'Probation List',        
      }
    },
  }
</script>
